
<div class="modal-header no-print">
  <h5 class="modal-title fo-modal-title">Pré-visualização</h5>
  <button type="button" class="fo-modal-close" aria-label="Fechar" (click)="fechar()">
    ×
  </button>
</div>

<div class="fo-preview">
  <div id="printOnly">
    <div class="fo-doc">
      <p *ngIf="!fichas.length" class="fo-preview-empty">
        Não foi possível carregar os dados da obra.
      </p>

      <article class="fo-ficha" *ngFor="let ficha of fichas">
        
        <header class="fo-head">
          <div>
            <span class="fo-brand">Rede de Obras</span>
            <div class="fo-title-row">
              <h1>{{ ficha.name }}</h1>
              <div class="fo-tags-head">
                <span class="fo-module" *ngIf="ficha.module">{{ ficha.module }}</span>
                <span class="fo-worktype" *ngIf="ficha.workType">{{ ficha.workType }}</span>
              </div>
            </div>
            <p class="fo-address">{{ ficha.address }}</p>
          </div>
          <div class="fo-head-id">
            <span class="fo-label">ID da obra</span>
            <span class="fo-id">{{ ficha.id }}</span>
          </div>
        </header>

        <div class="fo-summary">
          <div class="fo-cell">
            <span class="fo-label">Fase</span>
            <span class="fo-value" [class.fo-empty]="!ficha.phase">{{ ficha.phase || 'Não informada' }}</span>
          </div>
          <div class="fo-cell">
            <span class="fo-label">Término previsto</span>
            <span class="fo-value" [class.fo-empty]="!ficha.endingDate">{{ ficha.endingDate || 'Não definido' }}</span>
          </div>
          <div class="fo-cell">
            <span class="fo-label">Ficha atualizada</span>
            <span class="fo-value" [class.fo-empty]="!ficha.updateDate">{{ ficha.updateDate || 'Não informada' }}</span>
          </div>
          <div class="fo-cell">
            <span class="fo-label">Responsável</span>
            <span class="fo-value" [class.fo-empty]="!ficha.responsible">{{ ficha.responsible || 'Não definido' }}</span>
          </div>
          <div class="fo-cell">
            <span class="fo-label">Potencial</span>
            <span class="fo-value fo-stars" *ngIf="ficha.potential > 0; else semPotencial">
              <ng-container *ngFor="let star of stars">
                <span [class.fo-off]="star > ficha.potential">★</span>
              </ng-container>
            </span>
            <ng-template #semPotencial>
              <span class="fo-value fo-empty">Sem avaliação</span>
            </ng-template>
          </div>
        </div>

        <section class="fo-section" *ngIf="ficha.numbers.length || ficha.units.length">
          <h2>{{ ficha.numbersTitle }}</h2>
          <div class="fo-body">
            <dl class="fo-numbers" *ngIf="ficha.numbers.length">
              <div *ngFor="let item of ficha.numbers">
                <dt>{{ item.label }}</dt>
                <dd>{{ item.value }}</dd>
              </div>
            </dl>
            <div class="fo-subgroup" *ngIf="ficha.units.length">

              <div class="fo-units-grid" style="display:grid;width:100%;align-items:center" [style.grid-template-columns]="'30mm repeat(' + unitColumns(ficha.units).length + ', 1fr)'">
                <div class="fo-units-head" style="border-bottom:0.3mm solid #cfd4d9"></div>
                <div class="fo-units-head" style="text-align:center;padding:0 1.5mm 1mm;border-bottom:0.3mm solid #cfd4d9;font-size:6.5pt;font-weight:700;text-transform:uppercase" *ngFor="let column of unitColumns(ficha.units)">{{ column }}</div>
                <ng-container *ngFor="let unit of ficha.units">
                  <div class="fo-units-cell fo-unit-name" style="text-align:left;padding:1mm 1.5mm 1mm 0;border-bottom:0.2mm solid #e3e6e9;white-space:nowrap">{{ unit.name }}</div>
                  <div class="fo-units-cell fo-unit-value" style="text-align:center;padding:1mm 1.5mm;border-bottom:0.2mm solid #e3e6e9;white-space:nowrap" *ngFor="let column of unitColumns(ficha.units)">{{ unitValue(unit, column) }}</div>
                </ng-container>
              </div>
            </div>
          </div>
        </section>

        <section class="fo-section" *ngIf="ficha.companies.length">
          <h2>Empresas e contatos <small>{{ ficha.companiesSummary }}</small></h2>
          <div class="fo-body">
            <div class="fo-company" *ngFor="let company of ficha.companies">
              <div class="fo-company-head">
                <div>
                  <strong>{{ company.name }}</strong>
                  <span class="fo-company-meta" *ngIf="company.meta">{{ company.meta }}</span>
                </div>
                <div class="fo-company-phones">
                  <div *ngFor="let phone of company.phones">{{ phone }}</div>
                </div>
              </div>

              <div class="fo-contacts" *ngIf="company.contacts.length; else semContatos">
                <div class="fo-contact" *ngFor="let contact of company.contacts">
                  <strong>{{ contact.name }}</strong>
                  <span class="fo-role" *ngIf="contact.role">{{ contact.role }}</span>
                  <span class="fo-line" *ngFor="let line of contact.lines">{{ line }}</span>
                </div>
              </div>
              <ng-template #semContatos>
                <p class="fo-no-contacts">Nenhum contato cadastrado.</p>
              </ng-template>
            </div>
          </div>
        </section>

        <section class="fo-section" *ngFor="let section of ficha.tagSections">
          <h2>{{ section.title }}</h2>
          <div class="fo-body">
            <div class="fo-subgroup" *ngFor="let group of section.groups">
              <h3>{{ group.title }}</h3>
              <div class="fo-tags">
                <span class="fo-tag" *ngFor="let tag of group.tags">{{ tag }}</span>
              </div>
            </div>
          </div>
        </section>

        <section class="fo-section" *ngFor="let section of ficha.textSections">
          <h2>{{ section.title }}</h2>
          <div class="fo-body">
            <dl class="fo-details">
              <div *ngFor="let row of section.rows">
                <dt>{{ row.label }}</dt>
                <dd>{{ row.value }}</dd>
              </div>
            </dl>
          </div>
        </section>

        <section class="fo-section" *ngFor="let section of ficha.timelineSections">
          <h2>{{ section.title }}</h2>
          <div class="fo-body">
            <ol class="fo-timeline">
              <li *ngFor="let item of section.items">
                <time *ngIf="item.date">{{ item.date }}</time>
                {{ item.text }}
              </li>
            </ol>
          </div>
        </section>

        <section class="fo-section" *ngIf="ficha.updates.length">
          <h2>Últimas atualizações</h2>
          <div class="fo-body">
            <ol class="fo-timeline">
              <li *ngFor="let update of ficha.updates">
                <time *ngIf="update.date">{{ update.date }}</time>
                <strong *ngIf="update.title">{{ update.title }}</strong>
                <span class="fo-line" *ngIf="update.text">{{ update.text }}</span>
              </li>
            </ol>
          </div>
        </section>
      </article>
    </div>
  </div>
</div>

<div class="modal-footer no-print">
  <button type="button" class="fo-print-button" (click)="imprimir()" [disabled]="!fichas.length">
    Imprimir
  </button>
</div>